module.exports = __webpack_public_path__ + "static/media/cam-on.a9c7e91b.svg";